<svg
  viewBox="0 0 1440 919"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  class="u-display-block _ie-svg-fix"
>
  <defs>
    <linearGradient x1="54.09%" y1="155.4%" x2="54.09%" y2="-17.7%" id="a">
      <stop stop-color="#58D2F4" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="139.22%" y1="95.43%" x2="15.03%" y2="16.99%" id="b">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="41.62%" y1="-140.04%" x2="37.42%" y2="146.58%" id="c">
      <stop stop-color="#89E5FF" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </linearGradient>
    <radialGradient
      cx="51.21%"
      cy="-84.23%"
      fx="51.21%"
      fy="-84.23%"
      r="119.53%"
      gradientTransform="matrix(0 1 -.55419 0 .05 -1.35)"
      id="d"
    >
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </radialGradient>
    <linearGradient x1="100%" y1="128.81%" x2="0%" y2="-39.64%" id="e">
      <stop stop-color="#89E5FF" offset="0%" />
      <stop stop-color="#E6FDFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="50%" y1="4.42%" x2="50%" y2="98.36%" id="g">
      <stop stop-color="#FFCCB6" offset="0%" />
      <stop stop-color="#F682C0" offset="100%" />
    </linearGradient>
    <path
      d="M48.17 163.5c-16.57-6.01-30.13-19.39-40.66-40.13-15.8-31.1 0-63.57 0-81C7.51 30.73 6 16.8 2.97.53c15.8 17.93 22.92 41.66 21.36 71.2-1.55 29.54 9.35 58.39 32.7 86.54l-8.86 5.22z"
      id="f"
    />
    <path
      d="M60.5 81.68c-24.54-4.16-37.45-12.06-38.74-23.7-1.94-17.48 3.86-25.43-7.9-31.93C6.03 21.7 1.42 13.22.05.55 7.2 15.15 17.29 24.72 30.27 29.27c12.98 4.56 23.05 22.03 30.22 52.42z"
      id="i"
    />
    <path
      d="M5.62 119.78c-7.1-20.72-7.1-42.9 0-66.54C12.72 29.59 21.88 11.97 33.11.38c-10 19.61-13.64 39.51-10.91 59.7 4.1 30.27 2.6 58.62-5.5 68.66-5.39 6.7-9.08 3.7-11.08-8.96z"
      id="k"
    />
    <linearGradient x1="16.26%" y1="190.67%" x2="69.61%" y2="1.88%" id="m">
      <stop stop-color="#87A9E9" offset="0%" />
      <stop stop-color="#EF80BB" offset="100%" />
    </linearGradient>
    <path id="n" d="M14.35 103.67h40.01l13.08-90.63L60.94.06H7.12L.37 13.04z" />
    <linearGradient x1="68.73%" y1="18.62%" x2="40.1%" y2="127.71%" id="p">
      <stop stop-color="#80E3FF" offset="0%" />
      <stop stop-color="#4B7CD6" offset="100%" />
    </linearGradient>
    <path
      d="M48.17 163.5c-16.57-6.01-30.13-19.39-40.66-40.13-15.8-31.1 0-63.57 0-81C7.51 30.73 6 16.8 2.97.53c15.8 17.93 22.92 41.66 21.36 71.2-1.55 29.54 9.35 58.39 32.7 86.54l-8.86 5.22z"
      id="q"
    />
    <path
      d="M60.5 81.68c-24.54-4.16-37.45-12.06-38.74-23.7-1.94-17.48 3.86-25.43-7.9-31.93C6.03 21.7 1.42 13.22.05.55 7.2 15.15 17.29 24.72 30.27 29.27c12.98 4.56 23.05 22.03 30.22 52.42z"
      id="s"
    />
    <path
      d="M5.62 119.78c-7.1-20.72-7.1-42.9 0-66.54C12.72 29.59 21.88 11.97 33.11.38c-10 19.61-13.64 39.51-10.91 59.7 4.1 30.27 2.6 58.62-5.5 68.66-5.39 6.7-9.08 3.7-11.08-8.96z"
      id="u"
    />
    <path id="w" d="M14.35 103.67h40.01l13.08-90.63L60.94.06H7.12L.37 13.04z" />
    <linearGradient x1="92.75%" y1="95.17%" x2="57.66%" y2="15.33%" id="y">
      <stop stop-color="#89E5FF" offset="0%" />
      <stop stop-color="#E6FDFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="68.73%" y1="18.62%" x2="71.62%" y2="179.47%" id="z">
      <stop stop-color="#80E3FF" offset="0%" />
      <stop stop-color="#4B7CD6" offset="100%" />
    </linearGradient>
    <linearGradient x1="33.79%" y1="-704.45%" x2="33.79%" y2="-94.63%" id="A">
      <stop stop-color="#86E4FF" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="41.76%" y1="-149.65%" x2="37.19%" y2="162.34%" id="B">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="34.47%" y1="100%" x2="34.47%" y2="-64.34%" id="C">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="41.49%" y1="100%" x2="41.49%" y2="12.72%" id="E">
      <stop stop-color="#B22B73" offset="0%" />
      <stop stop-color="#560932" offset="100%" />
    </linearGradient>
    <path
      d="M82.14.05c-9.57 80.23-9.57 129.48 0 147.76 8.74 16.7 23.45 33.12 44.14 49.23a2.54 2.54 0 0 1-1.56 4.53H6.52a2.53 2.53 0 0 1-1.9-4.2c18.02-20.41 28.72-36.93 32.08-49.56 3.6-13.5.18-62.75-10.25-147.76h55.69z"
      id="D"
    />
    <linearGradient x1="93.6%" y1="97.11%" x2="56.92%" y2="13.65%" id="G">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="64.46%" y1="25.67%" y2="93.35%" id="I">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M127.59 1.27c46-2.72 87.73 12.18 100.4 32.67 12.66 20.48 12.91 115.82 9.17 159.13-3.74 43.3-7.3 75.87-51.1 91.12-43.8 15.25-176.85 9.83-184.1-7.76-7.25-17.6 18.22-46.3 43.95-71.3 25.73-25 16.33-138.1 24.34-161.85 8-23.77 11.33-39.29 57.34-42z"
      id="H"
    />
    <linearGradient x1="50%" y1="112.2%" x2="50%" y2="23.97%" id="K">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M12.5 150.87a12.42 12.42 0 0 1-5.99-11.03c0-4.77 2-9 5.98-12.68-5.7-4.21-8.56-7.95-8.56-11.2 0-4.89 4.15-11.95 0-16.56-4.15-4.61-6.22-9.5 0-17.91 6.22-8.42-1.05-11.8 2.58-19.73 3.64-7.93 7-9.54 3.5-16.77s10.76-11.01 10.76-14.15c0-3.14-4.65-13.8 2.38-20.34C30.17 3.96 49.18 5.8 58.13 4c8.94-1.8 24.26-6.89 29.2-1.8 4.93 5.08 8.34 11.37 13.68 13.34 5.34 1.98 9.05 9.07 9.05 15.3v8.3c7.1 1.7 10.02 6.88 8.76 15.54-1.9 13-7.89 12.69-4.9 20.75 3 8.07 3.87 11.3 0 16.67-3.86 5.38-3.31 12.52 4.9 15.82 5.47 2.2 6.99 7.22 4.55 15.04 9.37 1.94 14.06 7.57 14.06 16.88 0 9.3-41.65 12.98-124.94 11.03z"
      id="L"
    />
    <path
      d="M43.2 19.21v82.53c0 44.42 5 103.74 2.5 111.33-2.5 7.58-10.46 18.42-24.73 27.2-14.28 8.76-25.41 20.77-19.12 20.77 6.3 0 57.9-6.94 61.08-13.86 3.19-6.92 1.43-63.69 13.83-119.2 12.4-55.51 26.4-119.5 26.4-125.3 0-5.8-23 0-40.23 0-11.49 0-18.06 5.51-19.74 16.53z"
      id="N"
    />
    <path
      d="M.57.61C-.9 37.3.72 72.7 5.43 106.85c7.05 51.22 15.84 100.23 11.45 112.97-4.4 12.74-15.08 33.6-11.45 36.84 3.62 3.23 36.57 2.63 41.43 0 4.86-2.63-6.17-31.04-6.17-45.96 0-14.92 3.93-55.45 11.92-77.04C57.93 119.27 59.73 95 58 60.81c11.48-10.8 17.23-18.03 17.23-21.7 0-3.66-14.82-15.59-44.46-35.79L.57.62z"
      id="P"
    />
    <path
      d="M45.71.6C26.31 45.22 13.45 77.59 7.11 97.7c-9.5 30.19-7.28 43.16-2.23 46.54 5.05 3.38 17.63-7.13 29.23-25.72 7.74-12.4 16.77-32.96 27.1-61.7V22.5L45.71.6z"
      id="R"
    />
    <linearGradient x1="69.99%" y1="90.68%" x2="104.09%" y2="30.19%" id="U">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M90.46 2.96c-11.69 1.73-21.38 4.03-29.08 6.9-11.55 4.32-29.82 7-27.57 8.89 2.24 1.88 3.96 2.19 0 3.62-3.96 1.43 1.3 6.82 5.89 9.18 4.58 2.37 1.7 5.02 1.7 8.28 0 2.17 3.73 7.07 11.17 14.7-3.61 22.7-3.61 38.27 0 46.7 5.41 12.62 24.07 36.79 20.8 74.14-3.29 37.34-7.34 29.16-39.56 46.71C1.58 239.63-.95 259.76.3 269.07c.85 6.2 3.7 10.06 8.57 11.56-1.9-7.7 8.38-11.56 30.82-11.56 33.66 0 70.15 7.57 81.91 15.72 11.76 8.14 19.07 19.59 13.15 25.18-3.95 3.72-6.76 6.7-8.45 8.92l2.07 5.17c17.34-6.34 28.5-14.83 33.46-25.47 7.45-15.95 5.64-18.21 12.59-22.32 6.96-4.12 18.15-23.41 18.15-49.1 0-25.67-21.63-37.18-21.63-77.15 0-39.97 30.6-115.87 36.52-121.76 5.9-5.9 8.21-6.71-3.34-12.55-11.55-5.84-35.25-10.23-44.55-12.75A78.52 78.52 0 0 0 139.84.3L98.26 68.03C92.79 61.9 89.17 54.56 87.4 46c-1.75-8.56-2.5-19.25-2.23-32.06l5.28-10.98z"
      id="T"
    />
    <linearGradient x1="69.99%" y1="90.68%" x2="27.15%" y2="-15.93%" id="W">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="69.99%" y1="90.68%" x2="69.99%" y2="-22.17%" id="X">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M136.49 53.04c6.68 10.04 6.68 20.62 0 31.75-10.03 16.7-42.58 71.11-53.8 78.34-11.22 7.22-12.64 3.72-19.8-5.54s-16.13-51.32-18.45-64.06c-2.3-12.74-10.73-47.95-13.17-49.5-2.44-1.55-13.5-5.29-17.09-8.38-.86-.74-2.84-2.22-3.58-4.5-.12-.38.2-.92-.39-2.03-.59-1.1-.84-4.16-.84-4.73 0-.56.54-2 .4-2.3-1.59-3.5.18-4.54-.4-6.92-.58-2.38 1.32-5.1 3.21-5.98 2.2-1.03 6.06.92 7.99 1.86 0-2.33-6.27-5-7.5-4.25-1.22.75-7 1.82-9.03 2.39C2 9.76-.38 7.55.8 6.8 2 6.06 7.63 3.15 9.37 2.3c1.74-.86 3.9-.97 7.4-1.64 3.5-.67 11.41 6.2 15.38 10.4 3.97 4.2 9.29 11.04 12.3 17.43 2 4.26 13.72 29.87 35.15 76.85 12.47-23.57 21.31-35.9 26.5-36.98 7.8-1.6 15.58-1.84 17.72-6.68 1.42-3.23 5.65-6.1 12.67-8.64z"
      id="Y"
    />
    <linearGradient x1="64.31%" y1="27.78%" x2="10.66%" y2="88.99%" id="aa">
      <stop stop-color="#B22B73" offset="0%" />
      <stop stop-color="#560932" offset="100%" />
    </linearGradient>
    <linearGradient x1="7.79%" y1="-20.94%" x2="87.3%" y2="50%" id="ab">
      <stop stop-color="#B22B73" offset="0%" />
      <stop stop-color="#560932" offset="100%" />
    </linearGradient>
    <path
      d="M81.43 0c-9.58 80.18-9.58 129.4 0 147.67 8.75 16.7 23.5 33.1 44.2 49.2a2.53 2.53 0 0 1-1.55 4.53H5.68a2.53 2.53 0 0 1-1.9-4.21c18.06-20.4 28.77-36.9 32.14-49.52 3.6-13.49.18-62.7-10.26-147.67h55.77z"
      id="ac"
    />
    <path
      d="M283.74 270.12c-5.79 21.88-11.47 37.74-77.55 46.06C140.12 324.5 76.84 324 34.1 281.2s-36.93-180.84-23.92-227C23.18 8.03 53.97.86 82.72.86c28.76 0 69.05 26.25 75.1 88.1 6.07 61.85 18.29 100.97 66.37 115.57 48.08 14.6 65.34 43.7 59.55 65.58z"
      id="ae"
    />
    <path
      d="M.6 9A135.34 135.34 0 0 1 8.44 33.3c3 13.25 1.96 27.18 13.85 24.45 11.9-2.72 20.17-7.22 28.18-4.97 8.01 2.25 12.86 6.9 29.84-1.12 16.98-8.04 42.1-20.89 43.18-27.6 1.08-6.71-4.26-13.29-9.63-10-5.36 3.29-9.6 7.53-20.64 7.53-11.04 0-42.75-12.48-42.75-9.4 0 2.06-.76 3.43-2.28 4.12-6.81-5.8-11.74-10.51-14.79-14.15C30.35-1.46 19.42.81.6 9z"
      id="ag"
    />
    <linearGradient x1="45.18%" y1="32.68%" x2="28.72%" y2="64.36%" id="ah">
      <stop stop-color="#B22B73" offset="0%" />
      <stop stop-color="#560932" offset="100%" />
    </linearGradient>
    <path
      d="M41.24.98C30.64 15.16 21.93 24.8 15.1 29.88 4.9 37.5-4.27 44.65 4.4 57.28 13.07 69.9 21.09 80 21.09 86.47c0 6.46-1.21 16.1 8.06 17.91 6.18 1.2 23.8 1.2 52.88 0 5.03-2.86 3.38-6.57-4.95-11.1-12.49-6.81-18.5-2.67-21.67-18.05-2.1-10.25 1.15-24.2 9.76-41.83L41.24.98z"
      id="aj"
    />
    <linearGradient x1="76.95%" y1="40.97%" x2="10.66%" y2="88.99%" id="ak">
      <stop stop-color="#B22B73" offset="0%" />
      <stop stop-color="#560932" offset="100%" />
    </linearGradient>
    <linearGradient x1="-3.77%" y1="-46.59%" x2="78.36%" y2="67.62%" id="an">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M37.42.05c8.34 5.48 27.95 10.2 58.83 14.16 46.33 5.94 143.66 40 135.07 72.35-5.73 21.57-37.95 78.09-96.68 169.54-9.8 1.18-19.4-3.57-28.8-14.27-9.42-10.69-14-21.07-13.76-31.15 24.94-59.14 41.62-94.62 50.04-106.42C150.54 92.46 103.39 65.57.67 23.6L37.42.05z"
      id="am"
    />
    <linearGradient x1="74.27%" y1="24.85%" x2="34.47%" y2="68.57%" id="aq">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M1.88 12.6c-6.9 40.38 11.1 66.15 54.03 77.3 42.92 11.15 84.7 14 125.32 8.56-2.4 34.08 8.21 68.33 31.82 102.75 23.6 34.43 35.26 53.24 34.95 56.43 20.8 1.22 35.5-1.22 44.08-7.29 8.59-6.07 12.18-10.95 10.78-14.63-17.77-21.03-32.52-46.48-44.27-76.36-17.62-44.83-23.9-94.38-37.1-101.41C212.69 53.25 165.63 34 80.31.18L1.88 12.6z"
      id="ap"
    />
    <linearGradient x1="23.59%" y1="91.11%" x2="104.09%" y2="30.19%" id="at">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M9.94 32.5c14.1-2.63 41.78 12.73 63.44 20.1 14.44 4.91 23.33 8.47 26.68 10.67 1.47-3.21 8.58-10.1 21.34-20.68 12.75-10.57 22.09-24.53 28-41.88 6.77 4.62 12.23 8.83 16.4 12.63 4.15 3.8 11.27 6.07 21.36 6.82-31.82 48.68-49.98 74.59-54.49 77.73-6.76 4.72-17.35-2.22-29.39 0-12.03 2.22-37.5 5.53-72.96-4.25C-5.13 83.86-4.16 35.14 9.94 32.5z"
      id="as"
    />
    <path
      d="M4.76 9.1c5.6-.58 11.2 3.57 16.83 12.44 8.45 13.31 26.7 85.14 31.5 106.87 4.82 21.72 9 55.62 15.34 63.38 4.22 5.17 10.96 8 20.22 8.51-9.84-16.59-16.58-34.89-20.22-54.9-5.46-30.02 5.47-31.82 0-76.72C62.97 23.8 54.58 12.06 48.2 9.1 41.82 6.12 5.89-1.5 1.91 1.12-.74 2.88.21 5.54 4.76 9.1z"
      id="av"
    />
    <linearGradient x1="84.06%" y1="-9.44%" x2="32.49%" y2="80.9%" id="aw">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M115.28 258.22c1.55-38.02-.48-73.63-6.09-106.82-8.41-49.79-7.43-86.62-29.47-118.28C65.02 12.02 53.27 1.26 44.47.86 22.53 13.6 8.55 35.8 2.53 67.49-6.51 115.02 25.05 141.1 32 169.67c4.63 19.06 5.53 38.67 2.71 58.85 11.16 8.53 25.16 15.61 41.98 21.25 16.83 5.63 29.69 8.45 38.6 8.45z"
      id="ay"
    />
    <linearGradient x1="-37.04%" y1="20.3%" y2="20.3%" id="az">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="34.21%" y1="98.36%" x2="69.49%" y2="29.91%" id="aC">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M68.15 95.36c2.68-7.58 2.68-14.73 0-21.43C64.13 63.87 58 35.37 50.7 22.7 43.4 10.03 30.14.5 17.35.5 4.56.5-6.24 25.38 4.4 64.62c10.63 39.24 54.01 86.98 57.11 85.16 3.1-1.82 3.99-5.47 11.31-3.65 7.32 1.83 28.1-4.73 49.3-17.92 21.21-13.18 41.32-25.43 48.6-25.43 7.3 0 11.56-3.5 11.56-5.46s-9.07-11.6-9.07-22.16c0-10.54 7.07-12.49 3.53-14.13-3.53-1.64-16.39 8.3-25.7 12.9-9.32 4.6-30.82 11.04-49.08 11.04a59.72 59.72 0 0 0-33.81 10.39z"
      id="aB"
    />
    <linearGradient x1="35.04%" y1="220.38%" x2="35.04%" y2="109.41%" id="aG">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#FFF" offset="100%" />
    </linearGradient>
    <path
      d="M885.22 274.67l16.46-28.88a9.25 9.25 0 0 0-1.18-10.8C888.1 221.3 881 205.44 881 188.5c0-51.64 66.04-93.5 147.5-93.5s147.5 41.86 147.5 93.5-66.04 93.5-147.5 93.5c-29.28 0-56.57-5.4-79.52-14.74-1.18-.48-2.72-1.14-4.63-1.98a10.14 10.14 0 0 0-6.78-.5l-49.47 13.59a2.54 2.54 0 0 1-2.88-3.7z"
      id="aF"
    />
    <filter
      x="-68.5%"
      y="-79.7%"
      width="236.9%"
      height="316%"
      filterUnits="objectBoundingBox"
      id="aE"
    >
      <feOffset dy="53" in="SourceAlpha" result="shadowOffsetOuter1" />
      <feGaussianBlur
        stdDeviation="58.5"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      />
      <feColorMatrix
        values="0 0 0 0 0.0745098039 0 0 0 0 0.141176471 0 0 0 0 0.333333333 0 0 0 0.222769475 0"
        in="shadowBlurOuter1"
      />
    </filter>
    <linearGradient x1="22.05%" y1="110.63%" x2="74.43%" y2="9.26%" id="aH">
      <stop stop-color="#122F65" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M65.22 228.67l16.46-28.88a9.25 9.25 0 0 0-1.18-10.8C68.1 175.3 61 159.44 61 142.5 61 90.86 127.04 49 208.5 49S356 90.86 356 142.5 289.96 236 208.5 236c-29.28 0-56.57-5.4-79.52-14.74-1.18-.48-2.72-1.14-4.63-1.98a10.14 10.14 0 0 0-6.78-.5L68.1 232.37a2.54 2.54 0 0 1-2.88-3.7z"
      id="aJ"
    />
    <filter
      x="-68.5%"
      y="-79.7%"
      width="236.9%"
      height="316%"
      filterUnits="objectBoundingBox"
      id="aI"
    >
      <feOffset dy="53" in="SourceAlpha" result="shadowOffsetOuter1" />
      <feGaussianBlur
        stdDeviation="58.5"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      />
      <feColorMatrix
        values="0 0 0 0 0.0745098039 0 0 0 0 0.141176471 0 0 0 0 0.333333333 0 0 0 0.222769475 0"
        in="shadowBlurOuter1"
      />
    </filter>
    <linearGradient x1="13.49%" y1="10.55%" x2="90.39%" y2="92.04%" id="aK">
      <stop stop-color="#FFE2D5" offset="0%" />
      <stop stop-color="#EA85BB" offset="100%" />
    </linearGradient>
    <linearGradient x1="84.91%" y1="79.48%" x2="22.14%" y2="-12.29%" id="aL">
      <stop stop-color="#4F70AD" offset="0%" />
      <stop stop-color="#FC7FC1" offset="100%" />
    </linearGradient>
    <linearGradient x1="-38.86%" y1="153.03%" x2="41.89%" y2="43.26%" id="aN">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M177.3 1.42V0h97.13c-37.84 18.2-60.1 44.97-66.79 80.3-10.04 53-22.06 134.14-16.05 146.67 6.01 12.54 20.1 24.54 82.84 43.01 62.73 18.48 80.06 6.02 88.1 23.35H.39c8.04-17.33 25.36-3.45 88.1-21.92 62.74-18.47 76.82-30.48 82.84-43.01 6.01-12.54-6.02-93.68-16.05-146.67-6.7-35.33-28.95-62.1-66.79-80.3h88.8z"
      id="aM"
    />
    <linearGradient x1="24.78%" y1="-58.72%" x2="56.57%" y2="59.26%" id="aP">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="55.98%" y1="-57.09%" x2="37.41%" y2="76.72%" id="aQ">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="72.91%" y1="0%" x2="28.21%" y2="78.08%" id="aS">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M1.13 0c-1.1 16.48 1.24 28.2 7 35.15 8.64 10.43 27.83 9.47 37.04 6.48 9.2-3 13.95-16.54 14.78-23.73.56-4.8.56-10.76 0-17.9H1.13z"
      id="aR"
    />
    <linearGradient x1="56.31%" y1="-69.78%" x2="50%" y2="100%" id="aU">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="32.01%" y1="140.03%" x2="94.7%" y2="-159.35%" id="aV">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="70.33%" y1="100%" x2="61.5%" y2="0%" id="aW">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <path
      d="M1.23 36.91C-.22 23.93 2.9 14.54 10.57 8.72 22.08 0 42.22-1.56 55.35 3.58c13.13 5.14 21.21 15.5 33.29 18.72a103.62 103.62 0 0 0 25.9 3.32L82.12 44.09c-15.67 0-26.78-1.86-33.34-5.55-6.56-3.68-11.15-8-13.78-12.92L1.23 36.92z"
      id="aX"
    />
    <linearGradient x1="50%" y1="0%" x2="84.51%" y2="120.25%" id="aY">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="52.79%" y1="137.32%" x2="44.21%" y2="0%" id="ba">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="55.68%" y1="271.06%" x2="50%" y2="19.9%" id="bb">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="13.97%" y1="-6.95%" y2="93.35%" id="bd">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path id="bc" d="M.27 2.06l13.06 49.76 4.02 3.3.89-4.75L7.09.5z" />
    <linearGradient x1="77.41%" y1="74.68%" x2="3.5%" y2="-29.3%" id="bf">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="41.17%" y1="-80.6%" x2="66.69%" y2="73.58%" id="bg">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="77.88%" y1="-14.91%" x2="35.37%" y2="50%" id="bh">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="50%" y1="0%" x2="76.03%" y2="91.96%" id="bj">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M1.13 0c-1.1 16.48 1.24 28.2 7 35.15 8.64 10.43 27.83 9.47 37.04 6.48 9.2-3 13.95-16.54 14.78-23.73.56-4.8.56-10.76 0-17.9H1.13z"
      id="bi"
    />
    <linearGradient x1="34.44%" y1="-141.38%" x2="52.79%" y2="100%" id="bl">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="50%" y1="0%" x2="50%" y2="98.36%" id="bn">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <path
      d="M.16 24.49L32.76.85l70.1 4.66a13 13 0 0 1 4.54 7.16c.7 2.86.27 5.35-1.27 7.47L77.55 44.73c2.9-4.3 3.98-7.93 3.22-10.9a8.96 8.96 0 0 0-5.5-6.28L.16 24.5z"
      id="bm"
    />
    <linearGradient x1="63.71%" y1="-27.3%" x2="58.88%" y2="43.4%" id="bo">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="34.49%" y1="-23.79%" x2="62.33%" y2="50%" id="bq">
      <stop stop-color="#FF9161" offset="0%" />
      <stop stop-color="#B22B73" offset="100%" />
    </linearGradient>
    <linearGradient x1="56.92%" y1="79.1%" x2="20.78%" y2="-131.06%" id="br">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
    <linearGradient x1="50%" y1="0%" x2="50%" y2="96.83%" id="bt">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <path
      d="M.48.05V6.3l58.27 3.13L.48 15.26v3.28l77.94.8c3.5-3.67 5.25-7.5 5.25-11.48 0-3.98-3.67-6.59-11.03-7.81H.48z"
      id="bs"
    />
    <linearGradient x1="50%" y1="0%" x2="0%" y2="122.04%" id="bv">
      <stop stop-color="#00AEDF" offset="0%" />
      <stop stop-color="#122F65" offset="100%" />
    </linearGradient>
    <linearGradient x1="50%" y1="117.63%" x2="62.73%" y2="-24.57%" id="bw">
      <stop stop-color="#00C7FF" offset="0%" />
      <stop stop-color="#D9FBFF" offset="100%" />
    </linearGradient>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <path fill="#FFF" d="M0 0h1440v919H0z" />
    <g opacity=".5">
      <path
        fill="url(#a)"
        d="M3.84 9.19h889.68v554.46H3.84z"
        transform="translate(201)"
      />
      <path
        d="M382.17 574.7h-48.4v-.2H212.82V130.26l130.6-76.62v154.52l38.75-24.5V98.03h232.35V575.9H382.17v-1.2zm283.39-1.23V214.93l91.85-80.2h146.52V62.75h66.22v510.72H665.56zM981.4 101.09h113.12v474.82H981.4V101.09z"
        fill-opacity=".65"
        fill="#000"
        style="mix-blend-mode: soft-light"
      />
      <path
        d="M249.8 9.19L13 437.19V9.2H249.8zm38.44 0h101.38L76.1 575.91H13V506.7L288.24 9.19zm213.24 0h38.45L226.4 575.91h-38.45L501.48 9.19zm76.9 0H842.9L529.4 575.91H264.86L578.38 9.19zm302.98 0h12.16v161.26l-224.3 405.46H567.84L881.36 9.19zm12.16 363.46v69.5l-74 133.76h-38.44l112.44-203.26zm0 139.01v64.25h-35.54l35.54-64.25z"
        fill="url(#b)"
        style="mix-blend-mode: soft-light"
        opacity=".74"
        transform="translate(201)"
      />
      <path
        d="M279 15.32H19.13v389.04H279V15.32zm15.29 0v389.04h324.07V15.32H294.3zm339.36 0v389.04h253.76V15.32H633.65zm253.76 404.36H633.65v150.1h253.76v-150.1zm-269.05 150.1v-150.1H294.3v150.1h324.07zm-339.36 0v-150.1H19.13v150.1H279zM.78 0H902.7v582.03H.8V0z"
        fill="url(#c)"
        transform="translate(201)"
      />
      <path fill="url(#d)" d="M0 750.52h1440V919H0z" />
      <g>
        <path
          d="M108.3 167.25s3.49-20.85-15.15-45.56c-18.64-24.7.26-54.98 7.7-76.01 4.96-14.03.66-29.1-12.91-45.2 4.51 15.15 1.24 30.2-9.83 45.2-16.6 22.48-28.56 62.48-7.97 89.48 20.58 26.99 38.15 32.1 38.15 32.1z"
          fill="url(#e)"
          transform="translate(1 621.86)"
        />
        <g transform="translate(42.8 622.86)">
          <mask id="h" fill="#fff">
            <use xlink:href="#f" />
          </mask>
          <use fill="url(#g)" xlink:href="#f" />
          <path
            d="M4.36 46.78c7.08 48.43 22.81 80.38 47.2 95.86 24.39 15.48 21.72 27.34-8 35.57l-53.2-10.34-17.27-97.95L4.36 46.78z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#h)"
          />
        </g>
        <path
          d="M58.93 162.57c-11.58-29.17-20.13-49.17-25.63-60-5.5-10.82-11.42-24.32-17.77-40.48a127.9 127.9 0 0 1 36.65 45.64c8.8 18.2 21 35.8 36.6 52.81l-29.85 2.03z"
          fill="url(#e)"
          transform="translate(1 621.86)"
        />
        <g transform="translate(1 700.44)">
          <mask id="j" fill="#fff">
            <use xlink:href="#i" />
          </mask>
          <use fill="url(#e)" xlink:href="#i" />
          <path
            d="M20.47 38.44C26.77 60.5 41.3 71.52 64 71.52c22.7 0 17.54 9.5-15.5 28.48-25.14-17.45-37.71-26.95-37.71-28.48 0-1.53 3.23-12.56 9.7-33.08z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#j)"
          />
        </g>
        <g transform="translate(97.83 654.49)">
          <mask id="l" fill="#fff">
            <use xlink:href="#k" />
          </mask>
          <use fill="url(#e)" xlink:href="#k" />
          <path
            d="M30.17 56.96C11.13 77.36 1.6 100.6 1.6 126.66c0 39.1 46.2 40.65 48.71 22.5 1.68-12.1-5.04-42.83-20.14-92.2z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#l)"
          />
        </g>
        <path
          d="M113 158.85c-2.86-20.16 1.98-35.54 14.53-46.13 12.55-10.6 24-28.4 34.36-53.43-3.93 33.95-9.05 55.98-15.37 66.1-9.47 15.17-27.13 24.75-30.33 33.46-2.13 5.81-3.2 5.81-3.2 0z"
          fill="url(#m)"
          transform="translate(1 621.86)"
        />
        <g transform="translate(52.97 791.34)">
          <mask id="o" fill="#fff">
            <use xlink:href="#n" />
          </mask>
          <use fill="url(#e)" xlink:href="#n" />
          <path
            d="M-13.23-6.77C7.07 42 33.7 74.56 66.67 90.9c49.45 24.5-20.98 38.55-30.71 35.88-9.73-2.67-59.78-3.57-59.78-7.47 0-2.6 3.53-44.63 10.59-126.08z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#o)"
          />
        </g>
        <path
          fill="url(#p)"
          d="M58.95 169.55L39.9 157.43h91.41l-18.43 12.12z"
          transform="translate(1 621.86)"
        />
      </g>
      <g>
        <path
          d="M108.3 167.25s3.49-20.85-15.15-45.56c-18.64-24.7.26-54.98 7.7-76.01 4.96-14.03.66-29.1-12.91-45.2 4.51 15.15 1.24 30.2-9.83 45.2-16.6 22.48-28.56 62.48-7.97 89.48 20.58 26.99 38.15 32.1 38.15 32.1z"
          fill="url(#e)"
          transform="translate(1016.03 505.45)"
        />
        <g transform="translate(1057.83 506.45)">
          <mask id="r" fill="#fff">
            <use xlink:href="#q" />
          </mask>
          <use fill="url(#g)" xlink:href="#q" />
          <path
            d="M4.36 46.78c7.08 48.43 22.81 80.38 47.2 95.86 24.39 15.48 21.72 27.34-8 35.57l-53.2-10.34-17.27-97.95L4.36 46.78z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#r)"
          />
        </g>
        <path
          d="M58.93 162.57c-11.58-29.17-20.13-49.17-25.63-60-5.5-10.82-11.42-24.32-17.77-40.48a127.9 127.9 0 0 1 36.65 45.64c8.8 18.2 21 35.8 36.6 52.81l-29.85 2.03z"
          fill="url(#e)"
          transform="translate(1016.03 505.45)"
        />
        <g transform="translate(1016.03 584.03)">
          <mask id="t" fill="#fff">
            <use xlink:href="#s" />
          </mask>
          <use fill="url(#e)" xlink:href="#s" />
          <path
            d="M20.47 38.44C26.77 60.5 41.3 71.52 64 71.52c22.7 0 17.54 9.5-15.5 28.48-25.14-17.45-37.71-26.95-37.71-28.48 0-1.53 3.23-12.56 9.7-33.08z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#t)"
          />
        </g>
        <g transform="translate(1112.87 538.08)">
          <mask id="v" fill="#fff">
            <use xlink:href="#u" />
          </mask>
          <use fill="url(#e)" xlink:href="#u" />
          <path
            d="M30.17 56.96C11.13 77.36 1.6 100.6 1.6 126.66c0 39.1 46.2 40.65 48.71 22.5 1.68-12.1-5.04-42.83-20.14-92.2z"
            fill-opacity=".64"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#v)"
          />
        </g>
        <path
          d="M113 158.85c-2.86-20.16 1.98-35.54 14.53-46.13 12.55-10.6 24-28.4 34.36-53.43-3.93 33.95-9.05 55.98-15.37 66.1-9.47 15.17-27.13 24.75-30.33 33.46-2.13 5.81-3.2 5.81-3.2 0z"
          fill="url(#m)"
          transform="translate(1016.03 505.45)"
        />
        <g transform="translate(1068 674.93)">
          <mask id="x" fill="#fff">
            <use xlink:href="#w" />
          </mask>
          <use fill="url(#e)" xlink:href="#w" />
          <path
            d="M-13.23-6.77C7.07 42 33.7 74.56 66.67 90.9c49.45 24.5-20.98 38.55-30.71 35.88-9.73-2.67-59.78-3.57-59.78-7.47 0-2.6 3.53-44.63 10.59-126.08z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#x)"
          />
        </g>
        <path
          fill="url(#p)"
          d="M58.95 169.55L39.9 157.43h91.41l-18.43 12.12z"
          transform="translate(1016.03 505.45)"
        />
      </g>
      <g transform="translate(1179.5 205.24)">
        <path fill="url(#y)" d="M0 0h198.73v582.03H0z" />
        <path fill="url(#p)" d="M15.29 153.17h168.15v147.04H15.29z" />
        <path fill="url(#z)" d="M15.29 15.32h168.15v125.6H15.29z" />
        <path fill="url(#A)" d="M15.29 284.89h168.15v15.32H15.29z" />
        <g transform="translate(155.92 186.86)">
          <path fill="url(#e)" d="M0 0h24.46v98.03H0z" />
          <path fill="#FFF" d="M6.11 6.13h12.23v36.76H6.11z" />
          <ellipse fill="#FFF" cx="12.23" cy="61.27" rx="6.11" ry="6.13" />
        </g>
        <g transform="translate(27.52 186.86)">
          <path fill="url(#g)" d="M0 0h24.46v98.03H0z" />
          <path fill="#FFF" d="M6.11 6.13h12.23v36.76H6.11z" />
          <ellipse fill="#FFF" cx="12.23" cy="61.27" rx="6.11" ry="6.13" />
        </g>
        <g transform="translate(73.38 186.86)">
          <path fill="url(#m)" d="M0 0h24.46v98.03H0z" />
          <path fill="#FFF" d="M6.11 6.13h12.23v36.76H6.11z" />
          <ellipse fill="#FFF" cx="12.23" cy="61.27" rx="6.11" ry="6.13" />
        </g>
        <g transform="rotate(-20 593.84 -181.24)">
          <path fill="url(#g)" d="M0 0h24.46v98.03H0z" />
          <path fill="#FFF" d="M6.11 6.13h12.23v36.76H6.11z" />
          <ellipse fill="#FFF" cx="12.23" cy="61.27" rx="6.11" ry="6.13" />
        </g>
        <path
          fill="url(#e)"
          d="M0 0h21.4v85.77H0z"
          transform="translate(51.97 199.12)"
        />
        <path fill="#FFF" d="M58.08 205.25h9.17V242h-9.17z" />
        <ellipse fill="#FFF" cx="62.68" cy="252.72" rx="4.59" ry="4.59" />
        <path fill="url(#e)" d="M122.29 24.51h24.46v116.41h-24.46z" />
        <path
          fill="url(#e)"
          d="M0 0h24.46v98.03H0z"
          transform="rotate(-23 129 -12.78)"
        />
        <path
          fill="#FFF"
          d="M40.38 108.6l22.52-9.55 2.4 5.64-22.52 9.56zM46.37 122.7l22.52-9.55 2.4 5.64-22.52 9.56z"
        />
        <path fill="url(#g)" d="M152.87 49.01h24.46v91.9h-24.46z" />
        <path fill="#FFF" d="M122.29 52.08h24.46v6.13h-24.46z" />
        <path fill="url(#m)" d="M152.87 64.33h24.46v6.13h-24.46z" />
        <path fill="#FFF" d="M122.29 67.39h24.46v6.13h-24.46z" />
        <path
          fill="url(#B)"
          d="M73.38 324.71h12.23v33.7H73.38zM113.12 324.71h12.23v33.7h-12.23z"
        />
        <path
          d="M15.29 582.03h15.28v9.72c0 1.4-1.13 2.54-2.53 2.54H17.82a2.53 2.53 0 0 1-2.53-2.54v-9.72zM168.15 582.03h15.29v9.72c0 1.4-1.14 2.54-2.54 2.54H170.7a2.53 2.53 0 0 1-2.54-2.54v-9.72z"
          fill="url(#C)"
        />
        <path
          d="M98.97 307.37a1.53 1.53 0 1 1 3.05 0v264.17a1.53 1.53 0 1 1-3.05 0V307.37z"
          fill="#0C2F5F"
          fill-rule="nonzero"
        />
      </g>
    </g>
    <g transform="translate(781.34 671.29)">
      <mask id="F" fill="#fff">
        <use xlink:href="#D" />
      </mask>
      <use fill="url(#E)" xlink:href="#D" />
      <path
        fill-opacity=".53"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#F)"
        d="M17.63 27.65l73.69 50.52v-88.53l-107.94 2.3z"
      />
    </g>
    <path
      d="M69.45 178.58c-13.5 38.23-36.36 47.7-49.2 65.19-12.82 17.48-33.24 58.75-5.63 76 27.6 17.24 149.78 16.26 191.02 8.13 41.23-8.14 66.36-37.16 78.03-84.13 11.67-46.97.4-148.98-6-185.46C271.25 21.83 201.64.42 144.8.42c-56.84 0-66.06 48.89-66.06 77.73 0 28.84 4.2 62.2-9.3 100.43z"
      fill="url(#G)"
      transform="translate(673.48 350.53)"
    />
    <g transform="translate(692.8 358.73)">
      <mask id="J" fill="#fff">
        <use xlink:href="#H" />
      </mask>
      <use fill="url(#I)" xlink:href="#H" />
      <path
        d="M171.62 270.91c24.43-21.98 33.73-52.45 27.89-91.42-8.76-58.46 47.91-108.9 56.01-110.48 5.4-1.05-3.2-35.46-25.82-103.22L29.37-42.58C60.52 30.45 78.74 77.34 84.03 98.08c5.29 20.73 9.26 71.11 11.92 151.13l75.67 21.7z"
        fill-opacity=".65"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#J)"
      />
    </g>
    <path
      d="M92.83 431.2c10 9.05 19.9 15.03 29.67 17.93 9.77 2.9 9.77-15.57 0-55.41l-19.91 3.58-9.76 33.9z"
      fill="url(#K)"
      transform="translate(647 230)"
    />
    <g transform="translate(742.7 230)">
      <mask id="M" fill="#fff">
        <use xlink:href="#L" />
      </mask>
      <use fill="#6A4034" xlink:href="#L" />
      <path
        d="M32.18 3.06c-5.6 9.47-7 16.76-4.2 21.87 4.2 7.66-7.55 7.18-3.78 13.13 3.77 5.94-2.48 13.8-7.13 15.9C12.4 56.05 18 65.12 14.3 71c-3.7 5.88-6.93 9.03-4.33 15.54 2.6 6.51 3.6 16.57-7.94 22.88-7.68 4.2-8.78-13.52-3.28-53.18L9.98 9.2 24.2-.59l7.98 3.65z"
        fill-opacity=".53"
        fill="#FFF"
        style="mix-blend-mode: soft-light"
        mask="url(#M)"
      />
      <path
        d="M102.67 12.26c10.74 6.29 11.67 18.55 2.78 36.78-13.33 27.35-2.81 28.73 0 37.1 2.82 8.38-17.42 14.61-12.96 20.5 4.47 5.87-13.88 9.83-24.2 9.83-10.34 0-2.5 18.6 7.32 24.52 9.83 5.92 47.47 16.13 56.35 15.63 8.88-.5 35.18-13.52 29.86-32.96-3.55-12.97-13.5-41.59-29.86-85.85l-29.3-25.55z"
        fill-opacity=".31"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#M)"
      />
    </g>
    <g transform="translate(655.16 620.25)">
      <mask id="O" fill="#fff">
        <use xlink:href="#N" />
      </mask>
      <use fill="#D89565" xlink:href="#N" />
      <path
        d="M42 16.68c19.68-.3 31.34 2.53 34.99 8.5 5.46 8.97 10.81 13.7 0 22.9-10.82 9.22-12.76 11.55-4.45 16.48 8.32 4.93 3.3 76.28 0 94.78-2.2 12.34 3.25 12.34 16.33 0L106.86-7.89 62.5-16.92 29.85-4.06 42 16.68z"
        fill-opacity=".65"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#O)"
      />
      <path
        d="M32.08 59.17c23.84 55.54 38.26 99.74 43.27 132.61 5 32.88 22.23-27.92 51.67-182.39L17.32-40.66l14.76 99.83z"
        fill-opacity=".48"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#O)"
      />
    </g>
    <g transform="translate(759.97 622.31)">
      <mask id="Q" fill="#fff">
        <use xlink:href="#P" />
      </mask>
      <use fill="#D89565" xlink:href="#P" />
      <path
        d="M-7.89 7.06c33.5 10.72 52.77 18.36 57.8 22.9 7.54 6.82 2.46 21.1-6.1 22.14-8.55 1.05-6.09 12.57 0 27.59 6.1 15.02 4.35 94.16 0 111.82-2.9 11.78 7.63 13.16 31.58 4.14L123.58 44.4 49.9-14.27-7.9 7.06z"
        fill-opacity=".48"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#Q)"
      />
    </g>
    <path
      d="M792.69 335.3c3.1 9.92 3.1 16.98 0 21.18-3.1 4.2-11.1 7.44-23.99 9.73-1.47 22.92 1.38 40.35 8.55 52.28 10.76 17.91 7.38 21.96 15.44 14.63 8.06-7.34 37.6-69.04 41.63-71.83 4.03-2.79-9.02-.49-13.46-4.81-4.45-4.33-2.03-7.07 0-14.12 2.02-7.05-3.8-9.25-3.8-12.36 0-2.07 1.27-8.53 3.8-19.38h-12.42L792.7 335.3z"
      fill="#AF613F"
    />
    <g transform="translate(685.7 383.25)">
      <mask id="S" fill="#fff">
        <use xlink:href="#R" />
      </mask>
      <use fill="#D89565" xlink:href="#R" />
      <path
        d="M46.9 3.37c3.36 45.65-1.97 85.41-15.98 119.29-14.01 33.87 5.7 10.75 59.14-69.38L70.25 9.19 46.9 3.37z"
        fill-opacity=".53"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#S)"
      />
      <path
        d="M-.69 138.14c13.4-10.75 9.45-29.02 13.4-69.72 2.63-27.14-2.94-5-16.7 66.44 1.42 5.3 2.52 6.38 3.3 3.28z"
        fill="#FFF"
        style="mix-blend-mode: soft-light"
        opacity=".1"
        mask="url(#S)"
      />
    </g>
    <g transform="translate(689.74 359.73)">
      <mask id="V" fill="#fff">
        <use xlink:href="#T" />
      </mask>
      <use fill="url(#U)" xlink:href="#T" />
      <path
        d="M174.67 46.85c-31.56 21.19-47.34 38.95-47.34 53.3 0 5.4 23.95 36.53 21.26 42.9-8 18.94-48.64 14.58-39.85 21.46 11.75 9.2 54.3 34.58 62.8 61.35 8.51 26.77-1.53 41.86-14.77 39.8-13.24-2.07-16.35-1.86-8.18 12.32 8.18 14.18-9.32 34.51-46.2 39.78-36.9 5.26-4 27.58 10.62 27.58s59.03-10.08 67.04-10.08c5.34 0 31.52-36.47 78.53-109.4l-37.7-143.38-46.2-35.63z"
        fill-opacity=".65"
        fill="#000"
        style="mix-blend-mode: soft-light"
        mask="url(#V)"
      />
    </g>
    <path
      d="M133.58 132.31c-1.53 4.66-3.57 24.22-2.53 35.32.7 7.39 3.67 17.13 8.92 29.21-9-6.76-13.51-12.07-13.51-15.93 0-5.8 1.8-9.36-3.53-13.28-5.34-3.93-9.76-5.46-6.8-12.73 2.97-7.26 9-25.27 17.45-22.59z"
      fill="url(#W)"
      transform="translate(647 230)"
    />
    <path
      d="M141.75 196.27c6.35-16.81 13.62-31.78 21.8-44.89 12.26-19.66 17.29-23.09 18.9-23.09 1.6 0 10.85 3.75 7.12 5.68-3.73 1.92-6.63 6.43-4.15 10.97 2.47 4.53 4 9-2.97 13.17-6.98 4.17-3.34 9.39-6.6 14.65-2.17 3.5-13.54 11.34-34.1 23.51z"
      fill="url(#X)"
      transform="translate(647 230)"
    />
    <path
      d="M793.15 273.26c-1.79 2.37-4.36 3.56-7.73 3.56h-7.59c-1.4 3.32-4.12 6.05-8.15 8.2-6.04 3.22-.68 7.24-2.64 17.25-1.97 10-5.67 20.8 4.36 34.57 10.03 13.78 23.63 9.78 30.94 5.75 7.31-4.03 14.05-12 16.85-17.23 1.86-3.48 2.8-6.67 2.81-9.56 5.65 1.07 9.49-.92 11.5-5.96 3.01-7.57.67-14.87-4.81-14.87-3.66 0-6.83 2.43-9.5 7.3.49-6.23-.73-9.34-3.67-9.34-4.4 0-8.67-5.91-8.67-7.9 0-2-4.5-1.5-9.1-3.66-3.07-1.43-4.6-4.14-4.6-8.1z"
      fill="#D89565"
    />
    <path
      d="M776.97 330.12a.77.77 0 0 1 .16-1.52c6.68.73 12.6-.43 17.8-3.48a.76.76 0 0 1 1.04.27c.21.37.1.84-.27 1.05-5.49 3.22-11.74 4.45-18.73 3.68zM782.4 306.39c-3.53 2.74-4.7 5.1-3.53 7.07 1.18 1.98 3.14 2.86 5.89 2.65-2.78-1.88-4.16-3.5-4.16-4.85 0-1.34.6-2.97 1.8-4.87zM772.36 294.39c-1.12.22-1.74.69-2.12 3.73-.37 3.04.97 4.02 2.1 4.02 1.13 0 2.2-3.16 2.2-4.88 0-1.73-1.06-3.1-2.18-2.87zM796.79 295.3c-1.12.23-1.74.7-2.12 3.74-.38 3.04.97 4.02 2.1 4.02 1.13 0 2.2-3.16 2.2-4.88 0-1.73-1.06-3.1-2.18-2.87zM771.08 284.24c2.99-.5 5.11-.4 6.37.27 1.9 1.02 2.27 2.2 2.5 1.27.24-.93-2.86-3.1-3.96-3.71-.73-.4-1.18-.6-1.35-.6-.75.73-1.41 1.3-1.99 1.7l-1.57 1.07zM798.18 284.67a20.63 20.63 0 0 1 5.8-1.28c1.6.32 2.53.62 2.77.88.35.4.15 1.46.4 1.82.25.36-3-.69-5.98-.35-2.99.35-7.78 3.25-8.15 3.25-.37 0 2.48-3.29 5.16-4.32z"
      fill="#920E0E"
    />
    <g transform="translate(759.97 336.2)">
      <mask id="Z" fill="#fff">
        <use xlink:href="#Y" />
      </mask>
      <use fill="#D89565" xlink:href="#Y" />
      <g mask="url(#Z)" fill="#000" fill-opacity=".53">
        <path
          d="M79.7 106c3.22 7.81 5.5 13.58 6.84 17.3 2.02 5.6 1.07-28.07 7.1-43.42 4-10.24.7-12.3-9.95-6.18l-4 32.3z"
          style="mix-blend-mode: soft-light"
        />
        <path
          d="M106.6 65.62c8.6 2.58 15.64 2.58 21.12 0 8.22-3.87-36.32 91.76-55.2 104.02-12.6 8.17 2.2 10.8 44.42 7.9L156.27 60.1 138.8 34.78l-32.2 30.84z"
          style="mix-blend-mode: soft-light"
        />
      </g>
    </g>
    <path
      d="M74 604.6c-3.7 1.6-9.03 5.97-16 13.09-10.46 10.67-18.75 12.8-21.92 12.8-2.11 0 1.12-4.56 9.7-13.67a785.98 785.98 0 0 0-31.51 18.62c-11.59 7.33-21.11 20.38-7.37 20.38 13.74 0 51.17-7.54 57.73-9.4 6.55-1.85 7.87-2.79 9.7-14.68 1.22-7.92 1.1-16.97-.34-27.14z"
      fill="url(#aa)"
      transform="translate(647 230)"
    />
    <path
      d="M131.12 606.07c.81 8.55 2.11 15.08 3.89 19.6 2.67 6.78 5.95 8.23 11.75 0 3.86-5.48 6.16-12.02 6.9-19.6 6.88 21.62 10.32 35.1 10.32 40.42 0 7.98-29.74 8.76-40.93 6.9-11.2-1.85-9.13-13.5-4.13-23.24 3.34-6.5 7.41-14.52 12.2-24.08z"
      fill="url(#ab)"
      transform="translate(647 230)"
    />
    <path
      d="M771.74 337.65c5.28-.46 8.5-.48 9.67-.06 1.17.41 4.44 3.25 9.83 8.52"
      stroke="#7F3D30"
      stroke-width=".65"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g>
      <g transform="translate(247.57 679.77)">
        <mask id="ad" fill="#fff">
          <use xlink:href="#ac" />
        </mask>
        <use fill="url(#E)" xlink:href="#ac" />
        <path
          fill-opacity=".26"
          fill="#000"
          style="mix-blend-mode: soft-light"
          mask="url(#ad)"
          d="M95.22 45.27L8.48 143.66-12.93 4.15l118.88 14.23z"
        />
      </g>
      <g transform="translate(165 396.9)">
        <mask id="af" fill="#fff">
          <use xlink:href="#ae" />
        </mask>
        <use fill="url(#I)" xlink:href="#ae" />
        <path
          d="M-34.16 96.88C19.83 156.85 60.24 204 87.07 238.33c40.24 51.49 129.82 41.23 129.82 37.18 0-2.7-51.98-105.96-155.96-309.79L-34.16 96.88z"
          fill-opacity=".7"
          fill="#000"
          style="mix-blend-mode: soft-light"
          mask="url(#af)"
        />
        <path
          d="M75.38-6.91C42.85 3.19 30.71 47.1 38.95 124.8 51.3 241.35 70.89 281.86 194.93 277.05c82.7-3.2 128.4-13.66 137.1-31.38-42.46 59.17-69.1 90.14-79.9 92.93-10.8 2.8-96.56 2.8-257.3 0L-85.9 124.8-46.31-29 75.38-6.91z"
          fill="url(#G)"
          mask="url(#af)"
        />
        <path
          d="M116.2 212.42c56.26 71.17 91.93 118.61 107.04 142.31 22.66 35.56 123.37-1.4 107.56-35.1-15.82-33.71-34.74-106.62-39.04-104.15-2.87 1.65-61.39.63-175.55-3.06z"
          fill-opacity=".69"
          fill="#000"
          style="mix-blend-mode: soft-light"
          mask="url(#af)"
        />
      </g>
      <g transform="translate(204.75 254)">
        <g transform="translate(307.8 568.67)">
          <mask id="ai" fill="#fff">
            <use xlink:href="#ag" />
          </mask>
          <use fill="#943A31" xlink:href="#ag" />
          <path
            d="M46.93 27.36c-1.94-4.42-1.44-8.22 1.49-11.4 2.93-3.18-2.52-9.12-16.34-17.8L71.4 2.3C83.18 12.9 89.07 18.56 89.07 19.3c0 1.1-7.67 17.95-9.65 17.95-1.32 0-12.15-3.3-32.5-9.89z"
            fill="url(#ah)"
            mask="url(#ai)"
          />
          <path
            d="M1 34.06c11.82-5.48 18.24-7.77 19.25-6.85 1.52 1.38 6.25 8.55 10.29 8.55 2.68 0 5.53-4.2 8.55-12.62 21.18 3.86 35.63 1.96 43.34-5.7C93.99 5.95 142.56-.9 142.56.52c0 1.44-14.93 39.5-30.61 45.65-15.68 6.16-84.76 33.42-87.16 32.31-1.6-.74-9.53-15.54-23.8-44.42z"
            fill="url(#aa)"
            mask="url(#ai)"
          />
        </g>
        <g transform="translate(167.14 522.73)">
          <mask id="al" fill="#fff">
            <use xlink:href="#aj" />
          </mask>
          <use fill="#943A31" xlink:href="#aj" />
          <path
            d="M23.93 19.08C19.19 30.4 20.3 38 27.24 41.86c10.43 5.8 9.16 2.9 12.48 11.28 3.31 8.36 5.57 22.15 16.5 18.54 7.29-2.42 19.1 1.77 35.46 12.54 3.63 19.13 4.21 29.15 1.75 30.06-2.47.91-28.68-.68-78.65-4.77l-25.38-79.1 34.53-11.33z"
            fill="url(#ak)"
            mask="url(#al)"
          />
        </g>
        <path
          d="M40.23 59.5c-1.31-6.2-3-15.83 3.48-18.45 6.48-2.63 17.82 1.98 17.82 4.45 0 2.48-6.88 23-6.36 26.7.52 3.72-6.34 1.7-8.14 0-1.8-1.68-5.48-6.5-6.8-12.7z"
          fill="url(#ak)"
          transform="translate(167.14 522.73)"
        />
        <g transform="translate(108.03 307.31)">
          <mask id="ao" fill="#fff">
            <use xlink:href="#am" />
          </mask>
          <use fill="url(#an)" xlink:href="#am" />
          <path
            d="M94.08 162.42c15.4 32.34 39.77 51.78 73.11 58.33 33.34 6.54 51.2-21.42 53.6-83.91C157.83 64.72 121.7 21.17 112.37 6.17c-14-22.49-15.8 27.5-66.12 31.8-33.54 2.85-17.6 44.34 47.82 124.45z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#ao)"
          />
        </g>
        <g transform="translate(46.87 326.69)">
          <mask id="ar" fill="#fff">
            <use xlink:href="#ap" />
          </mask>
          <use fill="url(#aq)" xlink:href="#ap" />
          <path
            d="M55.85 6.45c12.7 38.76 36.61 62.26 71.73 70.5 52.68 12.37 75.2-3.7 70.6 14.78-4.59 18.48 14.64 130.13 99 162.8 56.23 21.78 27.95 43.48-84.85 65.1L-46.87 89.32l4.93-82.13 97.8-.74z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#ar)"
          />
        </g>
        <path
          d="M259.2 100.71c7.37-9.57 11.05-15.85 11.05-18.83 0-4.49-.4-23.13 3.85-26.3 4.24-3.18 10.38-1.27 14.95-6.39 4.58-5.11 6.3-8.24 7.23-4.12.63 2.75.63 4.47 0 5.16 18.26-15.44 27.83-22.03 28.7-19.79 1.3 3.37-2.65 11.67-6.05 14.63-3.4 2.96-11.28 10.5-13.73 14.8-2.44 4.3 1 11.72 3.31 16.37 2.3 4.65 1.3 15.9-4.62 20.19-5.93 4.28-13.76 4.33-23.01 20.2-6.17 10.58-13.4 5.27-21.68-15.92z"
          fill="#943A31"
        />
        <path
          d="M315.56 74.24c3.32 1.3 4.6 3.38 3.85 6.25-1.13 4.3-2.33 5.5-5.99 6.6-3.66 1.1-6.6 4.77-8.26 3.82-1.65-.95-1.15-6.64 1.37-10.42 1.68-2.52 4.69-4.6 9.03-6.25z"
          fill="#943A31"
        />
        <path
          d="M319.41 80.49c-1.13 4.3-2.33 5.5-5.99 6.6-3.66 1.1-6.6 4.77-8.26 3.82-1.65-.95-1.15-6.64 1.37-10.42"
          stroke="#490711"
          stroke-width=".97"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M312.3 65.1c3.65-1.05 6.03-.52 7.14 1.59 1.65 3.16 0 7.2-3.57 10.45-3.58 3.27-8.58 7.51-11.28 6.36-2.7-1.16-3.13-5.54 0-10.07a41.1 41.1 0 0 1 7.7-8.33z"
          fill="#943A31"
        />
        <path
          d="M315.87 77.14c-3.58 3.27-8.58 7.51-11.28 6.36-2.7-1.16-3.13-5.54 0-10.07"
          stroke="#490711"
          stroke-width=".97"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M316.18 58.68c0-4.57-6.26-4.26-9.22-2.13-2.97 2.13-9.7 12.33-8.73 16.36.96 4.02 4.06 4.48 6.4 3.15 2.33-1.33 11.55-12.8 11.55-17.38z"
          fill="#943A31"
        />
        <path
          d="M306.96 56.55c-2.97 2.13-9.7 12.33-8.73 16.36.96 4.02 4.06 4.48 6.4 3.15 1.22-.7 4.36-4.21 7.06-8.05"
          stroke="#490711"
          stroke-width=".97"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g transform="translate(107.03 90.83)">
          <mask id="au" fill="#fff">
            <use xlink:href="#as" />
          </mask>
          <use fill="url(#at)" xlink:href="#as" />
          <path
            d="M31.58 74.58c31.7 7.67 54.13 10.23 67.26 7.67 13.14-2.56 25.05 4.49 35.72 21.13l-100.27 8.9-21.7-18.64 18.99-19.06z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#au)"
          />
          <path
            d="M111.9 47.07c23.97-11.58 39.34-26.1 46.12-43.58 6.78-17.48.12-22.24-20-14.28L111.9 47.07z"
            fill-opacity=".72"
            fill="#FFF"
            style="mix-blend-mode: soft-light"
            mask="url(#au)"
          />
        </g>
        <path
          d="M183.84 263.87c9.1-6.21 15.22-8.29 18.33-6.21 4.67 3.1 9.46 7.37 16.12 6.2 6.65-1.16 10.76-.57 10.76-3.39 0-2.81 4.45-2.3 6.63-4.64 2.18-2.35 2.32-2.6 3.7-6.16 1.37-3.55 4.9 1 10.06 3.8 5.16 2.82 13.02 9.82 15.28 7 2.25-2.81-7.3-12.28-13.33-16.1-6.01-3.84-14.81-15.26-23.96-17.35-9.14-2.1-21.58-3.52-40.08 3.77-12.33 4.87-13.5 15.9-3.5 33.08z"
          fill="#943A31"
        />
        <path
          d="M93.16 345.27c30.8-6.3 50.9-15.97 60.28-29 14.06-19.56-3.94-.3-11.88-43.61-7.93-43.31-7.37-110.96-19.9-126.76-12.51-15.81-35.52-32.4-50.93-27.47-10.27 3.28-21.14 10.49-32.6 21.6l55.03 205.24z"
          fill="#FFF"
        />
        <g transform="translate(78.45 114.33)">
          <mask id="ax" fill="#fff">
            <use xlink:href="#av" />
          </mask>
          <use fill="url(#at)" xlink:href="#av" />
          <path
            d="M51.33 129.94c0-1.5.46-7.98 3.06-28.75s7.48-29.5 3.97-31.98c-3.52-2.47-14.38-11.5-10.7-17.55 3.67-6.04-6.45-27.88-19.18-37.02C15.76 5.5 7.64 2.72.23 7.26c-7.42 4.53 51.1 124.17 51.1 122.68z"
            fill="url(#aw)"
            mask="url(#ax)"
          />
        </g>
        <path
          d="M47.24 97.08A461.1 461.1 0 0 0 35.6 70.69C28.46 55.6 24.05 29.44 47.24 9.94c23.18-19.5 60.6-4.21 67.76 8.84 4.77 8.7-3.23 32.3-24 70.78l-33.64 13.85-7.53-1.74-2.6-4.59z"
          fill="#2F2725"
        />
        <path
          d="M46.85 96.43c1.06 6.46 1.06 12.34 0 17.64-1.57 7.95 5.55 17.3 17 21.74 11.45 4.44 22.38 1.08 22.38-3.24s-.19-21.65 6.78-24.33c6.97-2.67 18.04 7.16 25.94 3.58 7.9-3.58 10.69-22.41 10.69-35.91 0-13.5-5.46-30.35-5.46-39.39 0-6.03-3-11.97-9-17.83-.64 3.43-4.5 5.83-11.56 7.2-10.6 2.04-19.52 11.58-19.52 23.1 0 11.53 8.07 19.35 4.04 21.74-4.04 2.4-7.08-11.77-15.68-11.77-8.61 0-8.34 13.1-4.17 19.33 2.78 4.16 6.02 6.4 9.71 6.72-5.23-1.45-9.95 1.4-14.15 8.56-4.2 7.14-9.87 8.1-17 2.86z"
          fill="#943A31"
        />
        <path
          d="M287.3 82.63a.46.46 0 1 1-.9-.24c1.37-5.15.62-8.9-1.62-12.42a77.5 77.5 0 0 0-1.6-2.33c-.57-.82-.82-1.34-.82-1.87 0-.98.77-1.8 2.3-2.7.5-.3 1.08-.6 1.9-1.01l2.1-1.05c1.3-.66 2.25-1.2 3.07-1.79 2.29-1.62 3.73-4 4.34-7.19a.46.46 0 1 1 .9.18c-.65 3.4-2.22 6-4.71 7.76a25.6 25.6 0 0 1-3.18 1.86l-2.11 1.05c-.8.4-1.36.7-1.84.98-1.27.75-1.86 1.37-1.86 1.91 0 .28.2.68.66 1.35-.16-.23 1.21 1.7 1.63 2.35 2.37 3.74 3.17 7.74 1.73 13.16z"
          fill="#490711"
          fill-rule="nonzero"
        />
        <path
          d="M294.72 76.6c.76 3.12 1.57 7.75 2.44 13.9a.46.46 0 1 1-.91.12 153.93 153.93 0 0 0-2.42-13.8 43.36 43.36 0 0 0-2.74-8.06c-.24-.52.5-.93.8-.44 2.72 4.29 4.96 7.8 6.7 10.52l-.7.6-4.25-6.65c.4 1.2.75 2.47 1.08 3.81zM280.44 90.84a.46.46 0 0 1 .84-.36c1.67 4 3.97 7.1 6.9 9.35a.46.46 0 0 1-.56.73c-3.06-2.35-5.45-5.59-7.18-9.72z"
          fill="#490711"
          fill-rule="nonzero"
        />
        <g transform="translate(0 119.46)">
          <mask id="aA" fill="#fff">
            <use xlink:href="#ay" />
          </mask>
          <use fill="url(#U)" xlink:href="#ay" />
          <path
            d="M46.3-2.19c.1 8.76 3.1 15.25 9 19.47 8.88 6.33 12.2 17.08 12.2 24.23 0 7.15.31 12.87 3.05 14.92a30.63 30.63 0 0 0 7.41 3.82c-1.33 16.57-.87 25.78 1.39 27.64 3.37 2.78 11.12 10.12 13.93 17.4 2.81 7.27 7.07 25.27 14.42 24.26 4.91-.68 2.67-34.98-6.71-102.92L63.49-2.2H46.3z"
            fill="url(#az)"
            mask="url(#aA)"
          />
          <path
            d="M125.9 182.68c5.29 51.72 5.29 80.05 0 85-15.27 14.33-61.81-21.58-99.58-31.82-95.67-25.95-8.38-195.84 0-185.32 8.38 10.53 50.91 115.61 63.6 116.24 8.46.41 20.46 5.71 35.99 15.9z"
            fill-opacity=".26"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#aA)"
          />
        </g>
        <g transform="translate(13.23 166.4)">
          <mask id="aD" fill="#fff">
            <use xlink:href="#aB" />
          </mask>
          <use fill="url(#aC)" xlink:href="#aB" />
          <path
            d="M-1 18.06c13.52 55.13 29.46 87.2 47.81 96.21 27.53 13.51 26.5-11.78 31.08-3.8 4.58 8 41.75 10.7 75.03 1.7 33.29-9-80.37 79.8-85.21 78.27C62.86 188.91-52.34 41.1-52.34 41.1L-1 18.06z"
            fill-opacity=".24"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#aD)"
          />
        </g>
        <path
          d="M108.6 86.48c0 4.28 2.78 9.59 8.33 9.59 5.56 0 9.4-5.44 6.87-6.95-2.54-1.5-3.34-1.15-6.87-4.03-3.52-2.88-8.33-2.88-8.33 1.4z"
          fill="#490711"
          fill-rule="nonzero"
        />
        <ellipse fill="#490711" cx="107.03" cy="52.07" rx="3.06" ry="3.06" />
        <path
          d="M94.95 48.35c2.83-.43 5.84-1.93 9.02-4.52 4.78-3.88 8.64.94 8.64-1.27 0-2.22-5.92-4.94-9.49-2.22a59.46 59.46 0 0 0-8.17 8.01z"
          fill="#490711"
        />
      </g>
    </g>
    <g>
      <use fill="#000" filter="url(#aE)" xlink:href="#aF" />
      <use fill="url(#aG)" xlink:href="#aF" />
    </g>
    <g class="animation-floating">
      <path
        d="M1049.65 140.49c7.97 0 14.43 6.54 14.43 14.63l-.03 58.56h-27.73a14.7 14.7 0 0 1 3.67 9.76c0 8.09-6.47 14.65-14.44 14.65a14.52 14.52 0 0 1-14.43-14.63c0-3.75 1.4-7.17 3.68-9.76h-22.92v-17.25a18.94 18.94 0 0 0 9.63 2.61c10.63 0 19.25-8.75 19.25-19.52 0-10.78-8.6-19.52-19.23-19.52-3.51 0-6.8.96-9.63 2.62l.01-22.13 57.74-.02z"
        fill="url(#aH)"
        transform="rotate(-12 1027.98 189.29)"
      />
    </g>
    <g transform="matrix(-1 0 0 1 417 0)">
      <use fill="#000" filter="url(#aI)" xlink:href="#aJ" />
      <use fill="url(#aG)" xlink:href="#aJ" />
    </g>
    <path
      d="M1309.93 133.82l3.94 38.18h-8.83v-.05h-8.76l4.35-42.07-.55-.28c-17.25-8.81-28.14-22.06-24.32-29.58 3.83-7.52 20.9-6.47 38.16 2.34 17.25 8.82 28.14 22.06 24.32 29.58-3.09 6.08-14.82 6.56-28.31 1.88zm-7.08-9.66c11.25 5.74 22.54 6.14 25.21.87 2.68-5.26-4.27-14.2-15.52-19.94-11.25-5.75-22.54-6.14-25.22-.88-2.67 5.27 4.28 14.2 15.53 19.95z"
      fill="url(#aK)"
    />
    <path
      fill="url(#aL)"
      d="M1305.11 171.04h13.33L1332 205h-27.11v-.04H1278l13.56-33.96h13.55z"
    />
    <g>
      <g transform="translate(385 545.8)">
        <g transform="translate(177.3 67.37)">
          <mask id="aO" fill="#fff">
            <use xlink:href="#aM" />
          </mask>
          <use fill="url(#aN)" xlink:href="#aM" />
          <path
            d="M94.12 17.6c51.9 8.5 81.25 20.16 88.06 35.02 6.82 14.85 11.2 67.64 13.17 158.36L324.02-44.88 50.12-20.64l44 38.24z"
            fill-opacity=".65"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#aO)"
          />
        </g>
        <path
          d="M366.82 76.55c202.59 0 366.82-14.4 366.82-32.15V32.6a3345.2 3345.2 0 0 0-366.82-20.34C246.08 12.25 123.81 19.03 0 32.59V44.4c0 17.76 164.23 32.15 366.82 32.15z"
          fill="url(#aP)"
        />
        <ellipse fill="#FFF" cx="366.82" cy="33.68" rx="363.76" ry="32.15" />
        <ellipse fill="url(#B)" cx="366.82" cy="32.15" rx="366.82" ry="32.15" />
        <path
          d="M523.26 43.93c54.9 1.27 83.32 1.9 85.26 1.9 2.91 0 20.83-25.64 22.85-29.03 2-3.4 1.31-5.55-4.26-5.55-3.25 0-85.72-3.18-112.24 25.7-.93 1.02 15.49-1.88 14.68-.77a107.98 107.98 0 0 1-6.29 7.75zM54.43 33.06l149.9 6.88-37.95-33.29zM256.77 10.36c9.22 8.6 23.46 13.14 42.74 13.59 28.92.68 28.78-11.25 20.53-13.6-5.5-1.55-26.58-1.55-63.27 0zM174.24 10.36c9.21 8.6 23.46 13.14 42.74 13.59 28.91.68 28.77-11.25 20.53-13.6-5.5-1.55-26.59-1.55-63.27 0z"
          fill-opacity=".45"
          fill="#000"
          style="mix-blend-mode: soft-light"
        />
      </g>
      <g transform="matrix(-1 0 0 1 626.49 513.12)">
        <ellipse fill="url(#aQ)" cx="35.15" cy="43.4" rx="35.15" ry="7.66" />
        <path
          d="M47.3 30.27l-1.45-.46.06-1.52c.52-13.34 4.37-21.86 11.77-25.23 5.72-2.6 10.73.1 12.51 5.78a15.84 15.84 0 0 1-4.26 15.84c-5.95 5.69-12.23 7.62-18.63 5.59zm15.89-8.47a11.86 11.86 0 0 0 3.21-11.77c-1.1-3.52-3.66-4.9-7.08-3.35-5.48 2.5-8.67 9.13-9.36 20.17 4.4.86 8.76-.77 13.23-5.05z"
          fill="#B22B73"
        />
        <g transform="translate(4.06)">
          <mask id="aT" fill="#fff">
            <use xlink:href="#aR" />
          </mask>
          <use fill="url(#aS)" xlink:href="#aR" />
          <path
            d="M4.23-4.44c8.66 26.87 25.28 41.6 49.87 44.2 24.59 2.59-.51 11.78-75.3 27.57l-.34-67.57 25.77-4.2z"
            fill-opacity=".45"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#aT)"
          />
        </g>
      </g>
      <path
        d="M35.15 10.25c16.04 0 28.92-2.48 28.92-5.01C64.07 2.7 51.19.68 35.15.68 19.12.68 5.25 2.7 5.25 5.24c0 2.53 13.87 5 29.9 5z"
        fill="url(#aU)"
        transform="matrix(-1 0 0 1 626.49 508)"
      />
      <path
        fill="url(#aV)"
        d="M70.6 37.19H.36V25.63H72.5z"
        transform="translate(437.97 541.68)"
      />
      <path
        fill="url(#aW)"
        d="M.35 25.91L61.58 5.9h33.78L73.4 28.1z"
        transform="translate(437.97 541.68)"
      />
      <g transform="translate(507.27 541.68)">
        <mask id="aZ" fill="#fff">
          <use xlink:href="#aX" />
        </mask>
        <use fill="url(#G)" xlink:href="#aX" />
        <path
          d="M-1.1 21.23C6.03 14.54 13.1 11.2 20.1 11.2c6.98 0 12.06 5.47 15.23 16.41L-5.72 48.53l-6.84-16.77L-1.1 21.23z"
          fill="url(#aY)"
          mask="url(#aZ)"
        />
      </g>
      <path
        fill="url(#ba)"
        d="M.96 42.43l135.8 2.69 43.16-42.17L81.08 1.3z"
        transform="translate(690.68 546.8)"
      />
      <path
        fill="url(#bb)"
        d="M8.02 29.62L117.8 39.7 147.4 5.27 69.06.54z"
        transform="translate(690.68 546.8)"
      />
      <g transform="translate(832.3 518.25)">
        <mask id="be" fill="#fff">
          <use xlink:href="#bc" />
        </mask>
        <use fill="url(#bd)" xlink:href="#bc" />
        <path
          fill="url(#b)"
          mask="url(#be)"
          d="M2.06 12.88l10.36-2.4-1.5-4.5-12 3z"
        />
        <path
          d="M.6 10.4l11.62-2.77L9.36-2.42-4.69.7l5.3 9.7z"
          fill="url(#bf)"
          mask="url(#be)"
        />
      </g>
      <path
        d="M687.69 546.32c16.78 10.5 38.54 15.08 65.28 13.74 40.12-2 50.72 1.03 59.28 5.2 8.55 4.18 23.05 8.7 33.6 2.8 7.02-3.93-13.42-10.95-61.31-21.06l-74.94-1.08-21.91.4z"
        fill="#02518A"
        opacity=".29"
      />
      <path
        d="M689.42 523.66c-8.5 11.14-5.93 11.83 8.49 18.43s70.11 8.4 76.68 8.4c6.56 0 16.86-.2 21.26 3.3 4.39 3.49 13.86 8.9 17.62 10.71 3.75 1.81 15.84 1.65 20.92 0a28.7 28.7 0 0 0 8.73-4.47c7.87 1.73 12.64 2.91 14.3 3.53 2.5.94 3.77-4.1-1.13-7.98-4.9-3.89-11.06-6.06-16.48-8.84l-3.13-10.12c-4.54-3.5-12.28-1.46-16.2-1.46-5.73 0-21.34 4.23-31.83 2.9-10.49-1.32-49.4-21.66-60.3-24.7-10.91-3.03-30.44-.83-38.93 10.3z"
        fill="#D89565"
      />
      <path
        d="M844.67 542.33c3.3 5.4 4.95 8.5 4.95 9.32 0 .82-1.07.21-3.23-1.83l-1.72-7.49z"
        fill="#D89565"
      />
      <path
        d="M842.56 559.55l-5.25-1.13"
        stroke="#7F3D30"
        stroke-width=".65"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g>
        <g transform="translate(638.72 513.12)">
          <ellipse fill="url(#bg)" cx="35.15" cy="43.4" rx="35.15" ry="7.66" />
          <path
            d="M51.85 31.75l-1.44-.46.06-1.52c.52-13.34 4.36-21.86 11.76-25.23 5.73-2.6 10.74.1 12.52 5.78a15.84 15.84 0 0 1-4.26 15.84c-5.95 5.69-12.24 7.62-18.64 5.59zm15.9-8.47a11.86 11.86 0 0 0 3.2-11.77c-1.1-3.52-3.66-4.9-7.07-3.35-5.49 2.5-8.67 9.13-9.36 20.17 4.4.86 8.75-.77 13.22-5.05z"
            fill="url(#bh)"
          />
          <g transform="translate(4.06)">
            <mask id="bk" fill="#fff">
              <use xlink:href="#bi" />
            </mask>
            <use fill="url(#bj)" xlink:href="#bi" />
            <path
              d="M55.93-7.12C50.58 18.33 32.34 31.05 1.2 31.05c-31.14 0-21.06 7.71 30.23 23.14l43.1-14.43-7.11-46.88h-11.5z"
              fill-opacity=".45"
              fill="#000"
              style="mix-blend-mode: soft-light"
              mask="url(#bk)"
            />
          </g>
        </g>
        <path
          d="M35.15 10.25c16.04 0 28.92-2.48 28.92-5.01C64.07 2.7 51.19.68 35.15.68 19.12.68 5.25 2.7 5.25 5.24c0 2.53 13.87 5 29.9 5z"
          fill="url(#bl)"
          transform="translate(638.72 508)"
        />
      </g>
      <g>
        <path
          fill="url(#G)"
          d="M65.95 32.67L.67 34.73l24.87-11.81z"
          transform="translate(893.43 539.68)"
        />
        <g transform="translate(912.78 539.68)">
          <mask id="bp" fill="#fff">
            <use xlink:href="#bm" />
          </mask>
          <use fill="url(#bn)" xlink:href="#bm" />
          <path
            d="M73.96 30.28l33.36-28.62 6.19 17.83c-10 15.72-15.8 23.58-17.39 23.58-1.59 0-11.66 5.3-30.21 15.9l8.05-28.7z"
            fill="url(#bo)"
            mask="url(#bp)"
          />
          <path
            fill="url(#bq)"
            mask="url(#bp)"
            d="M60.28 29.37L92.85 2.18l-5.03-.81-34.05 29.25z"
          />
        </g>
        <path
          fill="url(#br)"
          d="M20.1 39.85L5.3 41l15.65-13.14 59.83 5.03-.87 3.42z"
          transform="translate(893.43 539.68)"
        />
        <g transform="translate(912.78 564.18)">
          <mask id="bu" fill="#fff">
            <use xlink:href="#bs" />
          </mask>
          <use fill="url(#bt)" xlink:href="#bs" />
          <path
            fill-opacity=".45"
            fill="#000"
            style="mix-blend-mode: soft-light"
            mask="url(#bu)"
            d="M59.22 9.25L12.02 22.4l-14.06 1.36-1.07-12.04z"
          />
        </g>
      </g>
      <path
        d="M849.56 551.39c-7.18-2.64-12.25-5.22-15.2-7.74-.57-.48-.2-.94 1.12-1.36"
        stroke="#7F3D30"
        stroke-width=".65"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M324.13 310.17a.74.74 0 0 1 .23-1.05.8.8 0 0 1 1.08.22c6.07 9.02 8.5 14.26 7.24 16.35a17.97 17.97 0 0 1-5.13 5.16.8.8 0 0 1-1.1-.16.74.74 0 0 1 .18-1.05 16.5 16.5 0 0 0 4.7-4.71c.78-1.3-1.6-6.43-7.2-14.76z"
      fill="#490711"
      fill-rule="nonzero"
    />
    <path
      d="M205.25 106.9c2.1-1.8 4.87-2.9 7.9-2.9 6.54 0 11.85 5.1 11.85 11.4 0 6.3-5.3 11.4-11.85 11.4-3.03 0-5.8-1.1-7.9-2.9V142h-13.96a14.7 14.7 0 0 0 2.11-7.6c0-8.4-7.07-15.2-15.8-15.2s-15.8 6.8-15.8 15.2c0 2.77.77 5.36 2.11 7.6H146V96.4c0-6.3 5.3-11.4 11.85-11.4h47.4v21.9z"
      fill="url(#aH)"
    />
    <path
      d="M209.75 181.1c-2.1 1.8-4.87 2.9-7.9 2.9-6.54 0-11.85-5.1-11.85-11.4 0-6.3 5.3-11.4 11.85-11.4 3.03 0 5.8 1.1 7.9 2.9V146h13.96a14.7 14.7 0 0 0-2.11 7.6c0 8.4 7.07 15.2 15.8 15.2s15.8-6.8 15.8-15.2c0-2.77-.77-5.36-2.11-7.6H269v45.6c0 6.3-5.3 11.4-11.85 11.4h-47.4v-21.9z"
      fill="url(#bv)"
    />
    <path
      d="M168.67 146.25c-1.87-2.04-3-4.74-3-7.7 0-6.38 5.28-11.55 11.8-11.55 6.51 0 11.8 5.17 11.8 11.55 0 2.96-1.14 5.66-3 7.7H205v13.61c-2.31-1.31-5-2.06-7.87-2.06-8.69 0-15.73 6.9-15.73 15.4s7.04 15.4 15.73 15.4c2.87 0 5.56-.75 7.87-2.06V204h-47.2c-6.52 0-11.8-5.17-11.8-11.55v-46.2h22.67z"
      fill="url(#bw)"
    />
  </g>
</svg>
